import { Axios } from '../axiosInstance';

const axiosInstance = Axios();

const viewUrlManager = {
  getViewUrl(url: any) {
    return axiosInstance.v2({
      url: url,
      method: 'POST'
    });
  }
};

export default viewUrlManager;
